// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminB2cPaymentSearchResponse

import { hydrateAdminB2cPaymentListItem, type AdminB2cPaymentListItem, type AdminB2cPaymentListItemApiResponse } from './adminB2cPaymentListItem.gen';

export type AdminB2cPaymentSearchApiResponse = {
	items: AdminB2cPaymentListItemApiResponse[];
};

export type AdminB2cPaymentSearch = {
	items: AdminB2cPaymentListItem[];
};

export function hydrateAdminB2cPaymentSearch(data: AdminB2cPaymentSearchApiResponse): AdminB2cPaymentSearch {
	return {
		...data,
		items: data.items.map(hydrateAdminB2cPaymentListItem),
	};
}